/**
 * Component Entry
 *
 */

import InfoCard from './InfoCard'
export default InfoCard
export * from './InfoCard'
